import { useCurrentApplication } from '@/graphql/services/application'
import { useListAlertsQuery } from '@/services/alerts'

export function useAlertsState(forceRefetch = false) {
  const { data: application } = useCurrentApplication()

  const { data: alertsResults } = useListAlertsQuery(
    {
      page_size: 200,
      application_id: application?.id,
      status: 'no-status',
    },
    {
      skip: !application?.id,
      refetchOnMountOrArgChange: forceRefetch,
      refetchOnFocus: forceRefetch,
      refetchOnReconnect: forceRefetch,
    }
  )

  const alerts = alertsResults?.results || []

  return {
    alerts,
  }
}
